import { AxiosResponse } from 'axios'
import { UserProfileDataType } from '../../models'
import fetch from '../fetch'

export type getWebUserParams = {
  webuserid: string
}

export default ({
  webuserid,
}: getWebUserParams): Promise<AxiosResponse<UserProfileDataType>> => {
  return fetch({
    method: 'GET',
    path: `api/v1/user-profile?webuserid=${webuserid}`,
  })
}
